<template>
  <div>
    <div v-if="criticalProducts.length > 0">
      <div  v-for="(product, index) in criticalProducts" :key="product.id">
        <a href="#" v-scroll-to="{el: '#Products'}">
          <div class="main-line-item">
            <div class="div-block-29">
              <div class="shortage-material-info-copy">
                <div class="div-block-24">
                  <div class="text-block-8">{{product.description}}</div>
                </div>
              </div>
              <div v-on:click="toggleRequest(index, product)" class="hide-material-requests">
                <div class="more-information-shortage">
                  Input Material Requests
                </div>
                <img v-if="productIndex !== index" src="../assets/images/expand_more-24px.svg" alt="" class="image-13">
                <img v-if="!isProductOpen && productIndex === index" src="../assets/images/expand_more-24px.svg" alt="" class="image-13">
                <img v-if="isProductOpen && productIndex === index" src="../assets/images/expand_less-24px.svg" alt="" class="image-13">
              </div>
            </div>
            <div class="offer-shortage-materials-container cta">
              <div v-if="product.demandCategory && !product.demandCategory.startsWith('Coming')" class="shortage-units cta">{{product.demandCategory}}</div>
              <div v-else class="coming-soon">{{product.demandCategory}}</div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div v-if="criticalProducts.length == 0" class="no-items-found">
      <div>No items found.</div>
    </div>
  </div>
</template>

<script>

  import {listService} from "../assets/js/services/listService";

  export default {
    name: 'CriticalProducts',
    data () {
      return {
        product: undefined,
        isProductOpen: false,
        productIndex: undefined,
        offerMaterial: undefined,
        selectedRequest: {},
        selectedRequests: [],
        isOfferMaterialModalOpen: false,
        criticalProducts: [],
        comingProducts: [
          {
            description: 'Testing Kits',
            id: 1,
            demandCategory: 'Coming Mid-May'
          },
          {
            description: 'Ventilators',
            id: 2,
            demandCategory: 'Coming Mid-May'
          },
          {
            description: 'Thermometers',
            id: 3,
            demandCategory: 'Coming soon...'
          },
          {
            description: 'Eye Protection',
            id: 4,
            demandCategory: 'Coming soon...'
          },
          {
            description: 'Gowns and Coveralls',
            id: 5,
            demandCategory: 'Coming soon...'
          },
          {
            description: 'Nitrile Gloves / Vinyl Gloves',
            id: 6,
            demandCategory: 'Coming soon...'
          },
          {
            description: 'Disposable Surgical Masks',
            id: 7,
            demandCategory: 'Coming soon...'
          },
          {
            description: 'Disposable N95 Masks',
            id: 8,
            demandCategory: 'Coming soon...'
          }
        ]
      }
    },
    created () {
      // this.criticalProducts = JSON.parse(localStorage.getItem('ProductsMaterialsList'));
      // if(!this.criticalProducts){
        //let _this = this;
        listService.listProducts()
                .then((response) => {
                  this.success = true;
                  this.criticalProducts = response.content.content;
                  this.criticalProducts.push(...this.comingProducts);
                })
                .catch(() => {
                  this.fail = true;
                });
      // }
    },
    methods: {
      toggleRequest: function (index, product) {
        this.product = JSON.parse(JSON.stringify(product));
        this.productIndex = index;
        this.selectedRequests = this.criticalProducts.filter(
                obj => obj.product.id === this.product.product.id
        );
        if (this.isProductOpen)
          this.isProductOpen = false;
        else
          this.isProductOpen = true;
      },
      toggleModal: function (request) {
        this.request = JSON.parse(JSON.stringify(request));
        this.selectedRequest = this.request;
        if (this.isOfferMaterialModalOpen)
          this.isOfferMaterialModalOpen = false;
        else
          this.isOfferMaterialModalOpen = true;
      },
      getMaterialName: function (request) {
        if (request.material) {
          return request.material.materialName;
        }
        return request.product ? "Finished Units" : ""
      },
      getRequestId: function (selectedRequest) {
        return selectedRequest.id.substr(selectedRequest.id.length - 8, selectedRequest.id.length);
      }
    }
  }
</script>
